import { render, staticRenderFns } from "./uploadPhoto.vue?vue&type=template&id=49cd1593&"
import script from "./uploadPhoto.vue?vue&type=script&lang=js&"
export * from "./uploadPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/upload/uploadPhoto.vue"
export default component.exports